<template>
  <div class="basic-block block-member-base" :style="styles">
    <div class="title-box">
      <h2><span class="title-head">占いTVは</span>斗弥と共演中の<br>人気占い師も占い放題！</h2>
      <img class="title-line" src="/static/img/recommend/lp/touwa/lp_titleline.svg" alt="">
    </div>
   

    <div class="content-wrap">
      <div class="block-member-base__inner">
        <div class="iconlist">
          <img  @click="onClickTarget(gadataInfo,'kurenotoriLink')" class="iconlist_icon" src="/static/img/recommend/lp/touwa/icon_kurenotori.png" alt="">
          <img  @click="onClickTarget(gadataInfo,'houenLink')" class="iconlist_icon" src="/static/img/recommend/lp/touwa/icon_houen.png" alt="">
          <img  @click="onClickTarget(gadataInfo,'kanoukokoLink')" class="iconlist_icon" src="/static/img/recommend/lp/touwa/icon_kanoukoko.png" alt="">
          <img  @click="onClickTarget(gadataInfo,'ottimoLink')" class="iconlist_icon" src="/static/img/recommend/lp/touwa/icon_ottimo.png" alt="">
        </div>
        <div class="block-deluxe-banner">
          <img src="/static/img/recommend/lp/touwa/membersbanner.png" alt="本格＆豪華占い" @click="onClickTarget(gadataInfo,'bannerLink')">
        </div>
        <div class="desc-box">
          <p class="desctext">（一部無料）4人で徹底鑑定！</p>
          <p class="desctext">気になるあの人の気持ち＆恋のゆくえ</p> 
          <p class="desctext-pink">￥888円（税込）</p>  
          <p class="desctext-pink">※月額会員の方は追加料金不要</p>
        </div>
        
        <div class="btn-area">
          <span class="button-link" @click="onClickTarget(gadataInfo,'buttonLink')"><span class="button-face">一部無料で占う</span></span>
        </div>
        
        
     
      </div>
      
      
    </div>
   
  </div>
</template>

<script>

import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'


export default {
  name: 'BlockMember',
  components: {
    LpBaseButton,
    BlockBanner,

  },
  props: {
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    lpId: Number,
    subscUrl: String,

    gadataInfo: {
      type: String,
    },


  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
    clicked () {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}-free-shindan-button`,
      })
      location.href = this.$handoverParams(`/recommend/lp/${this.lpId}/basic/input`)
    },
    clickedSubsc() {
      window.gtag('event', 'click', {
        'event_category': `LP${this.lpId}result-subsc-button`,
        'event_label': 'point5',
      })
      location.href = this.$handoverParams(this.subscUrl)
    },
    onDeluxeBannerClick(){
      window.gtag('event', 'click', {
        'event_category': 'LP3-deluxe-menu',
        'event_label': '10001'
      })
      location.href = this.$handoverParams('/deluxe/10001/input')
    },
    onClickTarget(gadataInfo,tagetData){
      if(this.gadataInfo == 'gaData'){
        if(tagetData in this.gaData){
          window.gtag('event', 'click', {
            'event_category':this.gaData[tagetData].eventCategory,
            'event_label':this.gaData[tagetData].eventLabel,
          })
          location.href = this.$handoverParams(this.gaData[tagetData].targetUrl)
        }
      }else if(this.gadataInfo == 'gaDataResult'){
        if(tagetData in this.gaData){
          window.gtag('event', 'click', {
            'event_category':this.gaDataResult[tagetData].eventCategory,
            'event_label':this.gaDataResult[tagetData].eventLabel,
          })
          location.href = this.$handoverParams(this.gaDataResult[tagetData].targetUrl)
        }
      }
      
    },
  },
  mounted(){
    //console.log(this.gadataInfo)
  },
  data(){
    return {
      gaData:{
        bannerLink:{
        targetUrl:'/deluxe/lp/1',
        eventCategory:'LP3-induction-button',
        eventLabel:'deluxe-lp-1',
        },
        buttonLink:{
        targetUrl:'/deluxe/10001/input',
        eventCategory:'LP3-induction-button',
        eventLabel:'deluxe-lp-1-input',
        },
        kurenotoriLink:{
        targetUrl:'/recommend/lp/1/',
        eventCategory:'LP3-induction-button',
        eventLabel:'lp1',
        },
        houenLink:{
        targetUrl:'/recommend/lp/4/',
        eventCategory:'LP3-induction-button',
        eventLabel:'lp4',
        },
        kanoukokoLink:{
        targetUrl:'/recommend/lp/2/',
        eventCategory:'LP3-induction-button',
        eventLabel:'lp2',
        },
        ottimoLink:{
        targetUrl:'/recommend/lp/5/',
        eventCategory:'LP3-induction-button',
        eventLabel:'lp5',
        }

      },
      gaDataResult:{
        bannerLink:{
        targetUrl:'/deluxe/lp/1',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'deluxe-lp-1',
        },
        buttonLink:{
        targetUrl:'/deluxe/10001/input',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'deluxe-lp-1-input',
        },
        kurenotoriLink:{
        targetUrl:'/recommend/lp/1/',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'lp1',
        },
        houenLink:{
        targetUrl:'/recommend/lp/4/',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'lp4',
        },
        kanoukokoLink:{
        targetUrl:'/recommend/lp/2/',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'lp2',
        },
        ottimoLink:{
        targetUrl:'/recommend/lp/5/',
        eventCategory:'LP3basicresult-induction-button',
        eventLabel:'lp5',
        }

      },

      
        
    
    }
  }
  
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

$uranaitv_black :#32373f;
$uranaitv_pink :#ff7497;
.block-member-base {
  background: #fff;
  padding: 40px 0 0;
  h2{
    font-style: normal;
    font-weight: 300;
    font-size: 22px;
    line-height: 30px;
    color: $uranaitv_black;
    margin:0;
    margin-bottom: 16px;
  }
  .iconlist{
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .iconlist_icon {
    width: calc(25% - 5px);
    img{
      width: 100%;
    }
  }
  .title-box {
    text-align: center;
  }
  .title-line{
    margin-bottom: 24px;
  }
  .block-deluxe-banner{
    margin-bottom: 10px;
    img{
      width: 100%;
    }

  }
  .desc-box{
    margin-bottom: 16px;
  }
  .desctext{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    margin:0;
  }
  .desctext-pink{
    color:$uranaitv_pink;
    font-size: 12px;
    font-weight: 600;
    margin:0;
  }
  .title-head{
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 16px;
    display: block;
  }
  

  &__inner {
    padding: 0 20px 20px;
    background: #fff;
   
  }
  
  
  .baseButton {
    width: 80%;
    max-width: 382px;
    margin: auto;
    /deep/ {
      .baseButton__button--primary {
        background: #6799CB;
        .baseButton__button__label {
          color: #6799CB;
          &::after {
            background-color: #6799CB;
          }
        }
      }
    }
  }
  

}

.btn-area {
  max-width: 315px;
  margin: auto;
}
.button-link {
  min-width: 270px;
  max-width: 400px;
  margin: 0 auto;
  font-weight: bold;
  font-size: 16px;
  color: white;
  min-height: 55px;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 100px;
  cursor: pointer;
  position:relative;
  background: $col_def_gradient;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
  user-select: none;
  &::before {
    position:absolute;
    top:0;
    left:0;
    z-index:-1;
    box-sizing:border-box;
    border-radius:100px;
    padding:2px;
    width:100%;
    height:100%;
    background:#fff;
    background-clip:content-box;
    content:"";
  }
  .button-face {
    color: $col_temp_key1;
    background: $col_def_gradient;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /deep/ {
      .notice,
      .face-body{
        display: block;
        width: 100%;
        color: $col_temp_key1;
        //グラデ方向崩れるため個別指定
        background: $col_def_gradient;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .notice {
        font-size: 0.8em;
        line-height: 1;
      }
    }
  }
  &.disable {
    pointer-events: none;
    background: #dcdfe2;
    .button-face {
      color: #dcdfe2;
      background: none;
      -webkit-text-fill-color: initial;
      -webkit-background-clip: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/blocks/BlockMember.vue